/*  ==============================================
//  Created by nguyendx                          ||
//  create at: 2017-09-26                        ||
//===============================================*/
import {Component, Injectable, OnInit} from '@angular/core';
import {FormBuilder, FormGroup} from '@angular/forms';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {UploadTickenService} from '../../../../common/services/UploadTicken.service';
import {ConfirmationService} from 'primeng/primeng';
import {Location} from '@angular/common';
import {EvsProductService} from '../../../../common/services/EvsProduct.service';
import {CategoryService} from '../../../../common/services/Category.service';

declare var $: any;

@Component({
    moduleId: module.id,
    selector: 'evs_product_view',
    templateUrl: './product_view.component.html',
    styleUrls: ['./product.css'],
    providers: [ConfirmationService, EvsProductService]
})

@Injectable()
export class EvsProductViewComponent implements OnInit {
    productEditForm: FormGroup;
    public message: { class: string, content: string } = null;
    public error: string = '';
    public routerChange: any;
    public product: any = {};
    public product_id: number = 0;
    public cateList: Array<Object> = [];
    public cateName: string = '';

    constructor(private _location: Location,
                public productService: EvsProductService,
                public router: Router,
                private activatedRoute: ActivatedRoute,
                public upload: UploadTickenService,
                private cate: CategoryService,
                private _fb: FormBuilder) {
    }

    ngOnInit() {
        this.routerChange = this.activatedRoute.params.subscribe((params: Params) => {
            this.product_id = params['id'];
            this.getDetailProduct(this.product_id);
        });
    }

    getDetailProduct(id) {
        this.productService.getDetaiById(id).subscribe(res => {
                if (res) {
                    if (!res.error) {
                        this.product = res.data;
                        this.getNameCate(this.product.cate_id)
                    } else {
                        this.message = {class: "alert alert-danger", content: 'Error: ' + res.message};
                    }
                }
            },
            error => {
                this.message = {class: "alert alert-danger", content: 'Error: ' + error};
            });
    }

    getNameCate(id: number) {
        if (id > 0 || id != null) {
            this.cate.find(id).toPromise().then(cat => {
                this.cateName = cat.name;
            });
        }
    }

    backToComponent() {
        this._location.back();
    }

}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/evs/product/product_view.component.ts